import { useDispatch, useSelector } from "react-redux";
import { resetDialogStages, setNewStage } from "../../actions/dialogRoute.action";
import { IReduxAppState } from "../../reducers";
import { setDialogHandle } from "../../actions/dialog";
import { IDialogHandleState } from "../../reducers/dialog";

/**
 * Hook for using multi staged modals and there paths allows setting of props to be used across the routes
 * @param history useHistory object for performing history actions
 * @returns 
 */
export function useDialogRouteStages(history: any): IUseDialogRouteStages {
    const dispatch = useDispatch();
    const { stages } = useSelector((state: IReduxAppState) => state.dialogRoutes);

    function goToNextStep(key: string, dialogState: Partial<IDialogHandleState<any>>, path: string, prevKey: string | null = null) {
        dispatch(setNewStage(key, dialogState, path, prevKey));
        history.push(path, {})
    }
    function goToPrevStep(stepKey: string) {
        const prevStage = stages[stepKey];
        if (!prevStage || !prevStage.prevKey) {
            closeAllModals();
            return;
        }
        history.replace(prevStage?.path!);
    }
    //setter
    function setProps(stageKey: string, key: string, data: any, property?: string) {
        if (stages[stageKey]) {
            if (property && stages[stageKey].ComponentProps[property]) {
                stages[stageKey].ComponentProps[property][key] = data
            }
            else stages[stageKey].ComponentProps[key] = data
        }
    }
    //getter
    function getProps(stageKey: string, key?: string, property?: string) {
        if (!stages[stageKey] && !key) return {};
        if (!stages[stageKey]) return undefined;
        if (property && stages[stageKey].ComponentProps[property]) {
            return stages[stageKey].ComponentProps[property][key!]
        }
        if (!key) {
            return stages[stageKey].ComponentProps;
        }
        return stages[stageKey].ComponentProps[key]
    }

    function closeAllModals(path?:string) {
        /**close last opened modal */
        dispatch(setDialogHandle({
            Component: null,
            ComponentProps: null,
            isOpen: false
        }));
        dispatch(resetDialogStages());
        if(path){
            history.push(path)
        }
    }
    return {
        goToNextStep,
        goToPrevStep,
        closeAllModals,
        getProps,
        setProps,
        stages
    }
}
